import { render } from "./SourcePopup.vue?vue&type=template&id=76f6f2d4&scoped=true"
import script from "./SourcePopup.vue?vue&type=script&lang=js"
export * from "./SourcePopup.vue?vue&type=script&lang=js"

import "./SourcePopup.vue?vue&type=style&index=0&id=76f6f2d4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f6f2d4"]])

export default __exports__